export default "__VITE_ASSET__BuuZ59Ti__"